module.exports = __webpack_public_path__ + "img/home-1.f4a081a7.png";